import React, { useEffect, useState } from 'react';
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { CiMenuFries } from "react-icons/ci";
import { MdOutlineCancel, MdOutlineMail } from "react-icons/md";
import { RiWhatsappFill } from "react-icons/ri";
import { IoIosCall } from "react-icons/io";
import { BASE_URL } from '../Config';
import axios from 'axios';
import { FaXTwitter } from 'react-icons/fa6';

export default function AnchorTemporaryDrawer() {
   useEffect(() => {
         
          footersection();
      }, []);

  const [sidebardata, setSidebardata] = useState('')
      const footersection = async () => {
          try {
              const response = await axios.get(`${BASE_URL}generalsetting`, {
                  headers: {
                      "content-type": "multipart/form-data",
                      Accept: "application/json",
                  },
              });
              if (response.data.success === true) {
  
                  
                  setSidebardata(response.data.data)
              } else {
                 
              }
          } catch (error) {
              console.error("Error fetching SEO data:", error);
          }
      };
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };
  const [pageLink, setPageLink] = useState('');
  const [pageTitle, setPageTitle] = useState('');

  useEffect(() => {
    setPageLink(window.location.href);
    setPageTitle(document.title.replace(/\&/g, '%26'));
  }, []);

  const fbsClick = () => {
    window.open(
      `http://www.facebook.com/sharer.php?u=${pageLink}&quote=${pageTitle}`,
      'sharer',
      'toolbar=0,status=0,width=626,height=436'
    );
    return false;
  };

  const tbsClick = () => {
    window.open(
      `https://twitter.com/intent/tweet?text=${pageTitle}&url=${pageLink}`,
      'sharer',
      'toolbar=0,status=0,width=626,height=436'
    );
    return false;
  };

  const lbsClick = () => {
    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${pageLink}`,
      'sharer',
      'toolbar=0,status=0,width=626,height=436'
    );
    return false;
  };

  const rbsClick = () => {
    window.open(
      `https://www.reddit.com/submit?url=${pageLink}`,
      'sharer',
      'toolbar=0,status=0,width=626,height=436'
    );
    return false;
  };

  const pbsClick = () => {
    window.open(
      `https://www.pinterest.com/pin/create/button/?&text=${pageTitle}&url=${pageLink}&description=${pageTitle}`,
      'sharer',
      'toolbar=0,status=0,width=626,height=436'
    );
    return false;
  };
  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 380 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div
        className="header-drawer"
        style={{ backgroundColor: "#000", height: "600px", padding: "30px" }}
      >
        <div className="drawer-top-header">
          <h2 style={{ color: "blue",cursor:"pointer" }}>
            <MdOutlineCancel />
          </h2>
        </div>
        <div className="" style={{color:"#fff"}}>
            <h3>Contact Us</h3>
            <p>{sidebardata.header_content}</p>
        </div>
        
            <div className="drawer_connection">
              <p><span style={{color:"red", fontSize:"22px"}}><IoIosCall /></span>&nbsp; +91 {sidebardata.header_contact_number}</p>
              <p><span style={{color:"#28a745", fontSize:"22px"}}><RiWhatsappFill /></span>&nbsp; +91 {sidebardata.footer_whatsapp_number}</p>
              <p><span style={{ fontSize:"22px"}}><MdOutlineMail /></span>&nbsp; {sidebardata.header_email}</p>

            </div>
            <div className="share-buttons-container">
      <div className="share-list">
        <a className="fb-h" href={sidebardata.facebook} target="_blank" rel="noopener noreferrer">
          <img src="https://img.icons8.com/material-rounded/96/000000/facebook-f.png" alt="Share on Facebook" />
        </a>
        <a className="tw-h" href={sidebardata.youtube} target="_blank" rel="noopener noreferrer">
          <img src="https://img.icons8.com/material-rounded/96/000000/youtube.png" alt="Share on Twitter" />
        </a>
        <a className="li-h" href={sidebardata.linkedin} target="_blank" rel="noopener noreferrer">
          <img src="https://img.icons8.com/material-rounded/96/000000/linkedin.png" alt="Share on LinkedIn" />
        </a>
        <a className="re-h" href={sidebardata.instagram} target="_blank" rel="noopener noreferrer" style={{background:"#ffffff"}}>
          <img style={{filter:"none"}} src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/500px-Instagram_icon.png"  />
        </a>
        <a className="pi-h" href={sidebardata.twitter} target="_blank" rel="noopener noreferrer" style={{background:"#fff",display:"flex",alignItems:"center",justifyContent:"center"}}>
          <FaXTwitter style={{color:"#000",fontSize:"28px"}} />
        </a>
      </div>
    </div>

      </div>
    </Box>
  );

  return (
    <div>
      {["right"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button
            onClick={toggleDrawer(anchor, true)}
            style={{ fontWeight: "700", color: "#000", fontSize: "22px" }}
            aria-label="Close drawer"
          >
            <CiMenuFries />
          </Button>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
